import styled from 'styled-components';

const statusColor = {
  PROCESSED: '#0081dc',
  READ: '#0aa700',
  UNREAD: '#dadada',
};

export const Container = styled.div`
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  font-size: 0.91rem;
  border-top: solid 1px #ececec;
  padding: 0 0 17px 0;

  @media screen and (min-width: 992px) {
    flex-direction: row;
    padding: 10px 0 17px 0;
  }

  .infos-container {
    padding: 0 17px;
  }

  .infos-mobile {
    display: flex;
    align-items: center;
    padding-top: 5px;

    > * {
      margin: 0 11px;

      &:first-child {
        margin-right: 0;
        margin-left: 0;
      }

      &:last-child {
        margin-right: 0;
      }
    }
  }

  .status-label {
    font-size: 0.88rem;
    font-weight: normal;
    background-color: ${({ status }) => statusColor[status]};
    padding: 0 5px;
    border-radius: 4px;
  }

  .title {
    font-size: 1.05rem;
    margin: 10px 0;
  }

  .see-more {
    display: inline-block;
    color: #12482d;
    margin-right: 10px;

    &:hover {
      text-decoration: underline;
    }
  }

  .process,
  .see-more {
    cursor: pointer;
    font-weight: bold;
    display: inline-block;
    margin-top: 8px;
  }

  .process {
    border: solid 1px rgb(24, 83, 53);
    border-radius: 6px;
    color: rgb(24, 83, 53);
    padding: 3px 6px;
    background-color: transparent;
  }

  .infos {
    display: flex;
    margin-top: 10px;
    flex-direction: column;
    align-items: flex-start;

    @media screen and (min-width: 992px) {
      align-items: center;
      flex-direction: row;
    }

    &__item {
      font-size: 0.88rem;
      font-weight: normal;

      &.last {
        &::after {
          content: '';
        }
      }

      @media screen and (min-width: 992px) {
        &::after {
          display: inline-block;
          content: '|';
          margin: 0 10px;
          font-weight: 100;
          color: #dadada;
        }
      }
    }

    &__journal,
    &__availability {
      font-weight: bold;
      display: inline-block;

      @media screen and (min-width: 992px) {
        &::after {
          display: inline-block;
          content: '|';
          margin: 0 13px;
          font-weight: 100;
          color: #dadada;
        }
      }
    }
  }
`;
